export default __webpack_public_path__ + "static/media/Ride.f03f5a83.wav";